import Component from './instagram_campaign_analytics_dialog.vue'
export default Component
